import React from "react"
import DataShop from "../../../data/shop"
import BarHoriRelative from "../../../components/charts/barHoriRelative"
import Donut from "../../../components/charts/donut"
import Util from "../../../util/util"

import "./UserAssets.less"
let moneyNames = ["10万以下", "10-30万", "30-60万", "60-100万", "100万以上"]
// 经济画像
export default class UserAssets extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      list: [],
      pagination: { pageSize: Util.isMobile ? 10 : 15 },
      loading: true,
    }
    this.columns = [
      {
        title: "Mac",
        dataIndex: "mac",
        sorter: (a, b) =>
          parseInt(a.mac.replace(":", ""), 16) -
          parseInt(b.mac.replace(":", ""), 16),
        width: "25%",
      },
      {
        title: "男/女",
        dataIndex: "gender",
        width: 100,
      },
    ]
    this.changePage = this.changePage.bind(this)
  }
  componentDidMount() {
    this.getData()
  }
  getData() {
    let { id, date } = this.props
    this.setState({ loading: true })
    DataShop.getUserAssets(id, date).then((data) => {
      let { money, house, car } = data
      this.setState({
        house,
        car,

        money: money.map((a, i) => {
          return {
            name: moneyNames[i],
            value: a,
          }
        }),
      })
    })
  }

  changePage(pagination) {
    this.getData(pagination.current)
  }

  render() {
    let { money = [], house, car } = this.state
    return (
      <div className="box-user-assets">
        <div>
          <h2 className="visit-h2 shop-body-title">
            <i className="icon" />
            <span className="i-title">经济状况</span>
          </h2>
          <div className="chart-asset-con">
            <BarHoriRelative list={money} />
          </div>
        </div>
        <div>
          <div className="pie-charts">
            <Donut value={car} name="有车" />
            <Donut value={house} name="有房" color="#E7A849" />
          </div>
        </div>
      </div>
    )
  }
}
